import {
  Button,
  Container,
  CssBaseline,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Paper,
  Typography,
} from '@mui/material'
import React, { useEffect, useState } from 'react'
import { Navigate, useNavigate, useParams } from 'react-router'
import { UserType } from 'redux/models/user'
import { EditActions, EditStoreStates } from '.'
import Form, { FormInputs } from '../Form'
import { DeleteButton } from './styles'

type OwnProps = {}
type EditProps = OwnProps & EditStoreStates & EditActions

const Edit = (props: EditProps) => {
  const { auth, notifications } = props
  const { loading, loaded, item } = notifications.edit
  const navigate = useNavigate()

  const [isOpenDialog, setIsOpenDialog] = useState(false)

  useEffect(() => {
    // お知らせの読み込み
    const { notificationId } = useParams<{ notificationId: string }>()
    notificationId && props.loadItem(notificationId)
  }, [])

  const onSubmit = (inputs: FormInputs) => {
    props.updateItem(inputs)
    navigate(-1)
  }

  const onDelete = () => {
    props.deleteItem()
    navigate(-1)
  }

  // 読み込みが終わるまで待機
  if (loading || !loaded) return <></>

  // 権限なしはリダイレクト
  if (!auth.user || auth.user.type === UserType.User) return <Navigate replace to="/notifications" />

  // お知らせが存在しなければリダイレクト
  if (!item) return <Navigate replace to="/notifications" />

  return (
    <Container>
      <CssBaseline />

      <Paper sx={{ mb: 2, p: 2 }}>
        <Typography variant="h4">「{item.title}」の編集</Typography>

        <Form submitTitle="更新" title={item.title} content={item.content} onSubmit={(inputs) => onSubmit(inputs)} />
      </Paper>

      <Paper sx={{ mb: 2, p: 2 }}>
        <DeleteButton fullWidth variant="contained" onClick={() => setIsOpenDialog(true)}>
          お知らせを削除
        </DeleteButton>
        <Dialog
          open={isOpenDialog}
          onClose={() => setIsOpenDialog(false)}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description">
          <DialogTitle id="alert-dialog-title">{'確認'}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">このお知らせを削除しますか？</DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setIsOpenDialog(false)} color="primary">
              キャンセル
            </Button>
            <DeleteButton onClick={() => onDelete()}>削除</DeleteButton>
          </DialogActions>
        </Dialog>
      </Paper>
    </Container>
  )
}

export default Edit
